// --------------------------------
// CREDIT SCORE
// --------------------------------
export const CREDIT_SCORE_OPTIONS = ['Below 500', '501 to 600', '601 to 700', '701 or above'];

// --------------------------------
// PROPERTY TYPE
// --------------------------------
export const PROPERTY_TYPE_OPTIONS = [
  { label: 'Single family home', value: 'single' },
  { label: 'Multi-family home (1-4 units)', value: 'multi 1-4' },
  { label: 'Multi-family home (5 or more units)', value: 'multi 5 plus' },
  { label: 'Condo/apartment', value: 'condo apt' },
  { label: 'Co-op', value: 'co-op' },
];

// --------------------------------
// PROPERTY USAGE
// --------------------------------
export const PROPERTY_USE_OPTIONS = [
  { label: 'Primary residence', value: 'primary' },
  { label: 'Vacation property', value: 'vacation' },
  { label: 'Rental property', value: 'rental' },
];

// --------------------------------
// EXPERIENCED FORECLOSURE/BANKRUPTCY?
// --------------------------------
export const FORECLOSURE_BANKRUPTCY_OPTIONS = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

// --------------------------------
// REJECTION MESSAGES
// --------------------------------
export const REJECTION_MESSAGES = {
  state: 'We are not yet operational in their state.',
  credit_score: 'Their FICO Score is too low.',
  property_type: "We currently aren't investing in co-ops or multi-family homes with more than five units.",
  property_usage: "We currently aren't investing in vacation properties under mortgage.",
  mortgage_balance: 'Their remaining mortgage balance makes them ineligible for a Hometap investment.',
  num_late_payments: 'They have had three or more late mortgage payments in the last 12 months.',
  foreclosure: 'They have experienced a foreclosure within the last 5 years. ',
  bankruptcy: 'They have experienced a bankruptcy within the last 5 years. ',
};

export const toURLParams = (object = {}) => {
  let paramStr = '';
  for (let key in object) {
    if (paramStr !== '') {
      paramStr += '&';
    }
    paramStr += key + '=' + encodeURIComponent(object[key]);
  }
  return paramStr;
};
